import React from 'react';
import Modal from 'react-modal';
import Cookies from 'js-cookie';
import _ from 'lodash';
import InputBox from './InputBox';
import MaterialUIMultiLine from './MaterialUIMultiLine';
import '../css/AddInternalVersion.css';
import Loader from './Loader';

import DragDrop from './drag/DragDrop';
import DragDropClick from './drag/DragDropClick';
// import createHistory from 'history/createBrowserHistory';
import SnackBar from './SnackBar'

// add internal version component.

const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    minHeight: '50%',
    maxHeight: '70%',
    overflow: 'auto',
    padding: '40px 90px 40px 90px',
    marginLeft: '260px',
    marginTop: '3%',
    background: '#EEF3F7',
    // background: 'none !important'
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "none",
    
  },
};

const customStylesSuccess = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    minHeight: '50%',
    maxHeight: '70%',
    overflow: 'auto',    
    padding: '2%',
    marginLeft: '260px',
    marginTop: '3%',
    background: '#EEF3F7',
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "none"
  },
};

export default class CompleteVersionNote extends React.Component{
  constructor(props) {
  super(props);

  this.state = {
    modalIsOpen: this.props.activeModal,
    modalStateAftereOpen: 'animated animated-duration-custom slideInDown',
    modalStateAftereOpenSuccess: 'animated animated-duration-custom slideInDown',
    modalIsOpenSuccess: false,
    versionUpdate: this.props.versionData, 
    presentVersion: [],
    completeVersionNote: '',
    fileNameCompleteReleaseNote: '',
    fileUploadCompleteReleaseNote: '',
    showError: false,
    loader: false,
    snackbarActive: false,
    snackbarMessage: ''
    }    
  
  this.openModal = this.openModal.bind(this);
  this.afterOpenModal = this.afterOpenModal.bind(this);
  this.closeModal = this.closeModal.bind(this);
  this.closeModalSuccess = this.closeModalSuccess.bind(this);
}

openModal() {
  this.setState({modalIsOpen: true});
}    

closeModalSuccess() {
  this.setState({
    modalStateAftereOpenSuccess: 'animated animated-duration-custom slideOutUp'
  },()=>{    
    setTimeout(()=>{
      this.setState({
        modalIsOpenSuccess: false
      },()=>{
        this.props.refreshVersion();        
      })
    }, 500);
  })
}
afterOpenModal() {
  // references are now sync'd and can be accessed.
  // this.subtitle.style.color = '#f00';
}

closeModal() {
  this.setState({
    modalStateAftereOpen: 'animated animated-duration-custom slideOutUp'
  },()=>{
    setTimeout(()=>{
      this.setState({
        modalIsOpen: false
      },()=>{
        this.props.refreshVersion();
      })
    }, 500);
  })
}

handleInputChange = (valueName,value) => {
     this.setState({
      completeVersionNote: value
    })
   }


handleSubmit = (das) =>{
 console.log('nothing to send')
}

updateVersion = () => {    
  let updateVersion = this.state.versionUpdate;
  updateVersion.push({
    compRelease_Note: this.state.completeVersionNote.trim(),
    file: this.state.fileUploadCompleteReleaseNote
  })
  
  this.setState({
    showError: true,
    loader: true
  })
  var tokenStored = localStorage.getItem('token');
  tokenStored = `Token ${tokenStored}`;
  var headers = {
    'Content-Type': 'application/json',
    "Access-Control-Allow-Origin": "*",
    'Authorization': tokenStored,
    'X-CSRFToken': localStorage.getItem('csrftoken')
  }
if(updateVersion.length!==0 && this.state.completeVersionNote.trim().length!==0 && this.state.fileUploadCompleteReleaseNote.length!==0){
  fetch('/cloud/versioncontrol/', {
    method: "POST",
    headers: headers,
    body: JSON.stringify(updateVersion)              
  })
           .then(response => {
              if(response.status===403){
                localStorage.removeItem('token');
                localStorage.removeItem('csrftoken');
                localStorage.removeItem('auth');
                // const history = createHistory({forceRefresh: true})
                window.location.href ='/session-timeout'
              }else{
                  return response.json()}
              })
  .then(data => {
    if(data.length!==0){
      this.setState({
        modalIsOpen: false,
        modalIsOpenSuccess: true,
        loader: false
      })
      // this.props.refreshVersion();
    }
  })
  .catch((err)=>{
    console.log(err)

  })
}else{
  this.setState({
    loader: false,
    snackbarActive: true,
    snackbarMessage :'Update complete release note with attachment having file size less than 5MB.'
  })
}
}

checkUpdateStatus = (name) => {
 if(this.state.versionUpdate[name]!==''){
   return 'normal'
  }else{
    return 'bold'
 }
}


updateHeadingVersionSection = (sectionName) =>{
  if(this.state.versionUpdate.hasOwnProperty(sectionName)){
    if(this.state.versionUpdate[sectionName]===''){
      return 'normal'
    }else{
      return 'bolder'
    }
  }else{
    return 'normal'
  }
}

handleChangeInputBox = (name, event) => {
  // this.setState({
  //   [name]: event
  // }); 
}

findErrorInVersion = (name, errorIn) => {
return false
}
// getBase64 = (event) => {
//   var input = event.target;
//   var reader = new FileReader();
//   if (input.files[0] !== undefined ? input.files[0].type === 'application/pdf' && input.files[0].size <= 5242880 : false) {
//     reader.onload = () => {
//       this.setState({
//         fileUploadCompleteReleaseNote: reader.result,
//         fileNameCompleteReleaseNote: input.files[0].name,
//       })
//     }
//   } else if (input.files[0] !== undefined ? input.files[0].type === 'application/pdf' || input.files[0].size <= 5242880 : false) {
//     alert("Upload .pdf file only and should have size of upto 5MB");
//   }
//   if (input.files[0] !== undefined) {
//     reader.readAsDataURL(input.files[0]);
//   }
// };



render(){
        return (
          <React.Fragment>
                    <SnackBar open={this.state.snackbarActive} handleSnackbarClose={()=>{    this.setState({
      snackbarActive: false
    })}} message={this.state.snackbarMessage}/>
               {this.state.loader  ? <Loader /> : null}
            <Modal
          isOpen={this.state.modalIsOpen}
          onAfterOpen={this.afterOpenModal}
          className={this.state.modalStateAftereOpen} 
          style={customStyles}
          contentLabel="Example Modal"
        >
          <div className="modal-add-device">
            <div className="float-right cross-times" onClick={this.closeModal}>
                <i class="fas   fa-2x mr-2"></i>
            </div>
          </div>
          <h3 className="modal-heading text-uppercase mb-2"  style={{ color: '#888888', fontSize: '30px',marginBottom: '30px'}} >RELEASE NOTE FOR PUBLIC VERSION</h3>      
          <div className="col-12 mx-0 px-0">   
        <div style={{borderBottom: '2px solid #E8E8EF',}}>
      <div className="d-flex align-items-center" style={{height: '5vh', backgroundColor: '#EEF3F7',  }}>        
        <div className="col-12  mx-0 px-0">
            For Complete Version
        </div>
      </div>     
       <div className="col-12  mx-0 px-0" style={{ backgroundColor: '#E8E8EF', borderTop: '2px solid #E8E8EF', padding: '10px 10px 30px 10px' }}>
       <div className="col-12 p-0">
          <MaterialUIMultiLine
            placeholder="Release Notes"
            label="Release Notes"
            rows={5}
            handleInputChange = {this.handleInputChange.bind(this)}
            handeSubmitReply={this.handleSubmit.bind(this)}
            name={'Complete version'}           
            inputValue={this.state.completeVersionNote}
            limitLength = {true}
            limitLengthValue = {450}          
            error={this.state.showError ? this.state.completeVersionNote.trim().length===0 ? true : false : false}
            errorText={this.state.showError ? this.state.completeVersionNote.trim().length===0 ? 'Please enter complete release notes' : '' : ''}
          />
        </div>   
        {/* <div className="row" style={{ paddingRight: '20px', paddingLeft: '20px', border: this.state.fileUploadCompleteReleaseNote==='' && this.state.showError ? "2px solid red" : "2px solid #EFF3F6", borderRadius: '12px', margin: '10px 10px 0px 10px' }}>
                  <div className="group pointer image-upload-version">
                    <label htmlFor="dd" style={{ pointerEvents: "all", width: '-webkit-fill-available' }}>Browse File: {this.state.fileNameCompleteReleaseNote}
                      <i class="fas fa-paperclip float-right" style={{ fontSize: '150%' }}></i>
                    </label>
                    <input id="dd" type='file' accept=".pdf" onChange={this.getBase64.bind(this)} style={{ display: 'none' }} />
                    <div className="group">
                      <span className="error text-danger" style={{ fontSize: '.75rem' }}></span>
                    </div>
                  </div>
                </div> */}
                 <div style={{marginLeft: '1%',marginTop: '1.5%', marginBottom: '-.75%', fontWeight: 'bolder'}}>ATTACHMENT</div>           
                <div className="d-flex">
                <div className="flex-grow-1" style={{height: '40px', paddingRight: '20px', paddingLeft: '20px', border: this.state.fileUploadCompleteReleaseNote==='' && this.state.showError ? "2px solid #EFF3F6" : "2px solid #EFF3F6", borderRadius: '12px', margin: '10px 10px 0px 10px' }}>
                <DragDrop 
                fileUpdate={(base64Data, file)=>{
                  this.setState({
                    fileUploadCompleteReleaseNote: base64Data,
                    fileNameCompleteReleaseNote: file.name,
                  })
                }}
                />
                </div>
                <div className="ml-auto" style={{height: '40px', width: '40px',padding: '8px 8px',maxWidth: '50px',
                backgroundColor: "#EFF3F6",
                border: this.state.fileUploadCompleteReleaseNote==='' && this.state.showError ? "2px solid #EFF3F6" : "2px solid #EFF3F6", borderRadius: '12px', margin: '10px 10px 0px 10px' }}>   
                <DragDropClick 
                fileUpdate={(base64Data, file)=>{   
                  this.setState({
                    fileUploadCompleteReleaseNote: base64Data,
                    fileNameCompleteReleaseNote: file.name,
                  })
                }}
                fileName ='ghnj'
                />               
                </div>   
                </div>  
                <div style={{marginLeft: '20px',width: '100%', marginTop: '-30px'}}>
                   { this.state.fileUploadCompleteReleaseNote!=='' ?<div  style={{ width: '100%' }}>Uploaded File: {this.state.fileNameCompleteReleaseNote}</div> : <div  style={{ width: '100%' }}>Drag and Drop or Attach files</div>}
                  </div>
                {this.state.fileUploadCompleteReleaseNote==='' && this.state.showError ? <div className="error text-danger" style={{ fontSize: '.75rem', marginLeft: '20px',marginTop: '8px' }}>  Please upload pdf file having maximum size of 5MB.</div> : null}
        </div>
      </div>    
     
            </div>
             <div className="float-right" style={{marginTop: '30px', marginBottom: '30px'}}>
             <div className="btn btn-new-grey"  onClick={this.closeModal} style={{marginRight: '15px'}}>Cancel</div>  
               <div className="btn btn-new-green" onClick={()=>{
                 if(this.state.completeVersionNote.trim()!=='' &&
                  this.state.fileUploadCompleteReleaseNote!==''){
                    this.updateVersion()
                  }else{
                    this.setState({
                      showError: true,
                   })
                  }
                 }} >Save</div>              
             </div>
        </Modal>
        <Modal
                 isOpen={this.state.modalIsOpenSuccess}
                 style={customStylesSuccess}
                 className={this.state.modalStateAftereOpenSuccess}
                  contentLabel="Example Modal">
              <div className="modal-add-device">
                <div className="float-right cross-times" onClick={this.closeModalSuccess}>
                  <i className="fas   fa-2x mr-2"></i>
                </div>
              </div>
            <div className="display-4 text-center">
            <h3 className="modal-heading thanks-message">Internal version updated successfully</h3>
                <i class="fas fa-check-circle update"></i>
                <br/>
                <div className="btn reset-btn mx-2 px-5"  onClick={this.closeModalSuccess}>
                              Close 
                            </div>
            </div>
            </Modal> 
          </React.Fragment>
        );
    }
}
